import module from 'nominas/nomina/module.js'
import template from './template.html'

export class NominasNominaInformacionConfiguracionEditarSuministro {
  data
  status
  monedas

  validacionesTipoCambio = {
    tipoMoneda: (value) => Number.isFinite(value) === false || (value > 0 && (this.data.id_moneda === 1 || value !== 1)),
  }

  calculatDivisa () {
    if (this.data.id_moneda === 1) {
      this.tipo_cambio = 1
      this.tipo_cambio_fecha = null
    }
  }
}

module.component('nominasNominaInformacionConfiguracionEditarSuministro', {
  controller: NominasNominaInformacionConfiguracionEditarSuministro,
  template,
  bindings: {
    data: '<',
    status: '<',
    monedas: '<',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/informacion/configuracion/editar/suministro/component.js